import { IconAngleRight, mapper } from '@maia/icons';
import { cardStyles, Typography } from '../../ui';

type EditCustomerCardProps = {
  label: string;
  subtitle: string;
  icon: string;
};

export function EditCustomerCard(props: EditCustomerCardProps) {
  const { label, subtitle, icon } = props;

  return (
    <div
      className={cardStyles({
        variant: 'elevated',
        className: 'flex gap-x-12 items-center p-24 cursor-pointer',
      })}
    >
      <i className="flex items-center justify-center w-24 h-24">
        {mapper(icon)}
      </i>
      <div className="flex flex-col">
        <Typography variant="body-xs" weight="medium">
          {label}
        </Typography>
        <Typography variant="body-xs" weight="regular" className="text-grayscale300">
          {subtitle}
        </Typography>
      </div>
      <IconAngleRight className="ml-auto w-24 h-24 text-info300" />
    </div>
  );
}
